export default {
    send: function (...arg) {
        if (window.require) {
            try {
                var electron = window.require('electron');
                return electron.ipcRenderer.send("on-call", ...arg);
            } catch (err) {
            }
        }
    },
    sendSync: function (...arg) {
        if (window.require) {
            try {
                // console.log("sendSync:",arg);
                var electron = window.require('electron');
                return electron.ipcRenderer.sendSync("on-call", ...arg);
            } catch (err) {
            }
            return { code: -1, msg: "调用sendSync失败" };
        }
    },
    awaitSendSync: function (...arg) {
        if (window.require) {
            try {
                // console.log("awaitSendSync:",arg);
                var electron = window.require('electron');
                return electron.ipcRenderer.sendSync("on-call-sync", ...arg);
            } catch (err) {
            }
            return { code: -1, msg: "调用sendSync失败" };
        }
    },
    invoke: async function (...arg) {
        if (window.require) {
            try {
                var electron = window.require('electron');
                // console.log("invoke前");
                var rs = await electron.ipcRenderer.invoke("handle-call", ...arg);
                // console.log("invoke完毕");
                return rs;
            } catch (err) {
            }
            return { code: -1, msg: "调用invoke失败" };
        }
    },
    bind: function (name, callback) {
        if (window.require) {
            let electron = window.require('electron');
            electron.ipcRenderer.removeAllListeners(name);
            //回调函数
            let myfunction = async function (...args) {
                var action = args[1];
                args.splice(1, 1);
                if (!action) {
                    action = name;
                }
                // console.log("action",action);
                let data = await callback(...args);
                // console.log("=========================data",data)
                electron.ipcRenderer.send("r-m-call", action, { code: 1, data: data });
                data = null;
            };
            // console.log("bind",name)
            electron.ipcRenderer.on(name, myfunction);

        }
    },
    openBrowse: function (url) {
        if (window.require) {
            const { shell } = window.require('electron');
            shell.openExternal(url);
        }
        return false;
    },
}